import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Textarea,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { createTodayTask } from "../actions/todaytask";
import { createInboxTask } from "../actions/inboxtask";
import { createWeeklyTask } from "../actions/weeklytask";
import { createProjectTask } from "../actions/projecttask";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  isProject?: boolean;
  projectId?: string;
};

const AddTaskModal = (props: Props) => {
  const dispatch = useDispatch();
  const [addTaskData, setAddTaskData] = useState({
    title: "",
    description: "",
  });
  const token = JSON.parse(localStorage?.getItem("token") as string);
  const addTodayTaskBoi = () => {
    dispatch(createTodayTask(addTaskData, token));
    setAddTaskData({
      title: "",
      description: "",
    });
    props?.onClose();
  };
  const addInboxTaskBoi = () => {
    dispatch(createInboxTask(addTaskData, token));
    setAddTaskData({
      title: "",
      description: "",
    });
    props?.onClose();
  };
  const addWeeklyTaskBoi = () => {
    dispatch(createWeeklyTask(addTaskData, token));
    setAddTaskData({
      title: "",
      description: "",
    });
    props?.onClose();
  };
  const addProjectTaskBoi = () => {
    dispatch(createProjectTask(token, props?.projectId as string, addTaskData));
    setAddTaskData({
      title: "",
      description: "",
    });
    props?.onClose();
  };
  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      size="xl"
      isCentered={true}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Task</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <div
            className="flex w-full flex-col rounded-2xl p-4 gap-2"
            style={{
              boxShadow:
                "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
              border: "1px solid #e6e6e6",
            }}
          >
            <Input
              variant="unstyled"
              placeholder="Task title"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAddTaskData({
                  ...addTaskData,
                  title: event?.target?.value,
                });
              }}
              value={addTaskData?.title}
            />
            <Textarea
              placeholder="Title description"
              variant="unstyled"
              resize="none"
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                setAddTaskData({
                  ...addTaskData,
                  description: event?.target?.value,
                });
              }}
              value={addTaskData?.description}
            />
          </div>
        </ModalBody>
        <ModalFooter display="flex" gap="1rem">
          <Button
            variant="outline"
            onClick={() => {
              props?.onClose();
            }}
          >
            Cancel
          </Button>
          {addTaskData?.title?.trim()?.length >= 1 ? (
            <Button
              colorScheme="blue"
              onClick={
                window.location.pathname === "/app/today"
                  ? addTodayTaskBoi
                  : window.location.pathname === "/app/inbox"
                  ? addInboxTaskBoi
                  : props?.isProject
                  ? addProjectTaskBoi
                  : addWeeklyTaskBoi
              }
            >
              Add Task
            </Button>
          ) : (
            <Button colorScheme="blue" isDisabled={true}>
              Add Task
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddTaskModal;
